<template>
    <div
        class="sidebar"
        :class="[{'collapsed': isCollapsed, 'is-collapsing': isCollapsing}, sidebarClasses]"
        v-if="loggedIn">
        <div class="sidebar__header">
            <span 
                v-if="title && (!isCollapsed && !isCollapsing)" 
                class="sidebar__title"
                @click="toggleProjects">
                {{title}}
                <i 
                    v-if="hasProjectMenu"
                    :class="projectsMenuExpanded ? arrowDownClass : arrowRightClass"
                    class="sidebar__project-switch"/>
            </span>
            <div 
                class="sidebar__toggle"
                @click="toggleCollapse">
                <div class="sidebar__toggle__icon">
                    <span/>
                    <span/>
                    <span/>
                    <span/>
                </div>
            </div>
        </div>
        <template v-if="hasProjectMenu && !isCollapsed">
            <ul 
                v-if="projectsMenuExpanded"
                class="sidebar__list sidebar__project-list">
                <li 
                    v-for="(item, index) in projects"
                    v-bind:key="index" 
                    class="sidebar__item">
                    <a 
                        class="sidebar__link"
                        :href="`${windowLocation}${item.href}`">
                        {{item.name}}
                    </a>
                </li>
            </ul>
        </template>
        <ul class="sidebar__list">
            <template v-for="(item, index) in menu">
                <item
                    :key="index"
                    :item="item"
                    :index="index"
                    :active="item.active"
                    :is-collapsed="isCollapsed"
                    :expanded-items="expandedItems"
                    :is-collapsing="isCollapsing"
                    :arrowDownClass="arrowDownClass"
                    :arrowRightClass="arrowRightClass"
                    :projectRootFolder="projectRootFolder"
                    @itemClick="onItemClick($event)"
                    @itemClickWithLink="onItemClickWithLink($event)"
                    @subItemClick="onSubItemClick($event)"/>
            </template>
            <li class="sidebar__item sidebar__item--my-account">
                <a 
                    :href="`${projectRootFolder}/api/auth/profile`"
                    class="sidebar__link">
                     <i 
                        class="sidebar__icon"
                        :class="myProfileIconClass"/>
                    <template v-if="!isCollapsed && !isCollapsing">
                        <span class="sidebar__link__title">My Profile</span>
                    </template>
                </a>
            </li>
            <li class="sidebar__item sidebar__item--logout">
                <a 
                    :href="`${projectRootFolder}/api/auth/logout`"
                    class="sidebar__link">
                     <i 
                        class="sidebar__icon"
                        :class="logoutIconClass"/>
                    <template v-if="!isCollapsed && !isCollapsing">
                        <span class="sidebar__link__title">Log Out</span>
                    </template>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import Item from './components/mag-sidebar-item.vue'
import SubItem from './components/mag-sidebar-sub-item.vue'
import { animationMixin } from './mixin' 

export default {
    name: 'SidebarMenu',
    components: {
        Item,
        SubItem
    },
    mixins: [animationMixin],
    props: {
        menu: {
            type: Array,
            required: true
        },
        sidebarClasses: {
            type: String,
            default: ""
        },
        title: {
            type: String
        },
        collapsed: {
            type: Boolean,
            default: false
        },
        hasProjectMenu: {
            type: Boolean,
            default: false
        },
        loggedIn: {
            type: Boolean,
            default: false
        },
        projectRootFolder: {
            type: String,
            default: "/"
        },
        closeAllItems: {
            type: Boolean
        },
        arrowDownClass: {
            type: String
        },
        arrowRightClass: {
            type: String
        },
        myProfileIconClass: {
            type: String
        },
        logoutIconClass: {
            type: String
        }
    },
    data() {
        return {
            isCollapsed: this.collapsed,
            isCollapsing: false,
            projectsMenuExpanded: false,
            expandedItems: [],
            projects: [
                {
                    "name": "Inventory",
                    "href": "/inventory/#"
                },
                {
                    "name": "Marketing",
                    "href": "/marketing/#"
                },
                {
                    "name": "Admin",
                    "href": "/admin/#"
                },
                {
                    "name": "Distribution",
                    "href": "/distribution/#"
                }
            ],
            windowLocation: ''
        }
    },
    watch: {
        collapsed(val) {
            immediate: true,
            this.isCollapsed = val
        },
        closeAllItems(){
            if(this.isCollapsed){
                this.expandedItems = []
            } else {
                this.expandedItems = [];
                this.isCollapsed = true;
            }
        }
    },
    created(){
        this.windowLocation = window.location.origin
    },
    methods: {
        toggleCollapse() {
            if(!this.isCollapsing){
                this.expandedItems = [];
                this.isCollapsing = true;
                this.isCollapsed = !this.isCollapsed;
                let vm = this;
                setTimeout(function(){
                    vm.isCollapsing = false;
                }, 150);
            } else {
                return
            }
            this.$emit('collapseChange', this.isCollapsed);
        },
        toggleProjects(){
            this.projectsMenuExpanded = !this.projectsMenuExpanded;
        },
        onItemClick(index) {
            if(this.expandedItems.includes(index)){
                const matchedIndex = this.expandedItems.indexOf(index);
                this.expandedItems.splice(matchedIndex, 1);
            } else {
                if(this.isCollapsed){
                    this.expandedItems = [];
                    this.expandedItems.push(index);
                } else {
                    this.expandedItems.push(index);
                }
            }
        },
        onSubItemClick(href){
            this.$emit('subItemClick', href);
        },
        onItemClickWithLink(href){
            this.$emit('itemWithLinkClick', href);
        }
    }
}
</script>

<style lang="scss" scoped></style>